const GROUP = /\B(?=(\d{3})+(?!\d))/g;

function groupIntString(absIntDigits: string): string {
  return absIntDigits.replace(GROUP, ' ');
}

/**
 * O'zbek so'mi: mingliklar orasida probel, qiymatdan keyin majburiy "UZS".
 * Masalan: 475000 → "475 000 UZS"
 */
export function formatMoneyUz(
  value: number | null | undefined,
  options?: { maximumFractionDigits?: number }
): string {
  const maxFrac = options?.maximumFractionDigits ?? 0;
  const n = Number(value);
  if (!Number.isFinite(n)) return '0 UZS';
  if (maxFrac <= 0) {
    const r = Math.round(n);
    const neg = r < 0;
    const body = groupIntString(String(Math.abs(r)));
    return `${neg ? '−' : ''}${body} UZS`;
  }
  const rounded = Number(n.toFixed(maxFrac));
  const neg = rounded < 0;
  const s = neg ? rounded.toFixed(maxFrac).slice(1) : rounded.toFixed(maxFrac);
  const parts = s.split('.');
  const intp = parts[0] ?? '0';
  const frac = parts[1];
  const body = groupIntString(intp);
  return `${neg ? '−' : ''}${body}${frac !== undefined ? `.${frac}` : ''} UZS`;
}

/** Minglik-probel raqamlar (dona, buyurtmalar soni va hokazo — valyutasiz) */
export function formatGroupedInt(value: number | null | undefined): string {
  const n = Math.round(Number(value));
  if (!Number.isFinite(n)) return '0';
  const neg = n < 0;
  const body = groupIntString(String(Math.abs(n)));
  return `${neg ? '−' : ''}${body}`;
}
